<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width">
        <div class="col-sm-12 col-md-2 d-print-none d-flex align-items-center">
          <span class="toolbar-title">{{ moduleTitle }}</span>
        </div>
        <div class="col">
          <nav mat-tab-nav-bar #tabs class="full-width">
            <a
              mat-tab-link
              *ngFor="let link of links"
              (click)="onTabChanged(link)"
              [routerLink]="['/rad-monitor']"
              [queryParams]="{ tab: links.indexOf(link) }"
              [active]="selectedTab == link.id"
            >
              {{ link.name }}
            </a>
          </nav>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
      #sidenav
      opened="true"
      class="mat-side-nav-rad d-print-none"
      mode="side"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section 1 -->
      <mat-nav-list>
        <mat-list-item>
          <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          >
          <filter-box
            (changed)="applyFilter($event)"
            *ngIf="isExpanded || isShowing"
          ></filter-box>
        </mat-list-item>

        <!-- Table -->
        <mat-list-item style="height: unset">
          <div [ngClass]="{ invisible: !isExpanded && !isShowing }">
            <!-- <template-side></template-side> -->
          </div>
        </mat-list-item>
      </mat-nav-list>

      <!-- Section 2 -->
      <mat-nav-list id="left-nav-buttons">
        <mat-list-item
          (click)="create()"
          class="parent"
          *ngIf="selectedTab == 0"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create Rad Monitor</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>

        <mat-list-item
          (click)="createLocation()"
          class="parent"
          *ngIf="selectedTab == 1"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create Location</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>

        <mat-list-item
          *ngIf="hasPrivilege(privilegeEnum.RadMonitorSettings)"
          (click)="settings()"
          class="parent line-top"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Settings</span
          >
          <mat-icon matListItemIcon class="gray">settings</mat-icon>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div class="sidenav-content">
          <!-- Main Content Here -->
          <rad-monitor-tab
            #monitor
            [filter]="filter"
            *ngIf="selectedTab == 0"
            (loading)="setLoading($event, loadingOrigin.Main)"
          ></rad-monitor-tab>
          <rad-monitor-location-tab
            #location
            [filter]="filter"
            *ngIf="selectedTab == 1"
            (loading)="setLoading($event, loadingOrigin.Main)"
          ></rad-monitor-location-tab>
        </div>
        <div
          class="buttons d-print-none"
          id="sidenav-content-buttons"
          [ngClass]="{}"
        ></div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- "loading">
    <!-- Copyright 2017 Google Inc. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->
  <!-- </overlay-loading> -->
</div>
